import { ListItem } from './top-search.interface';
import breadcrumbFormatter from '../../app/utility/breadcrumb-formatter';
import { stringFormatter } from "../../app/utility/string";

export default (items: ListItem[]): string => `${items.reduce((acc, item) => {
  return acc = acc + `
  <div class="result-item">
    <div class="breadcrumbs">
      ${breadcrumbFormatter(item.breadcrumb).reduce((acc, breadcrumb, index) => {
    return acc = acc + `
        <div class="breadcrumb-item">
          ${index > 0 ? `<i class="i i-divider"></i>` : ''}
          <a class="breadcrumb-link" href="${breadcrumb.url}">${breadcrumb.title}</a>
        </div>
        `
  }, '')}
    </div>
    ${item.title ? `
    <h5 class="no-margin">
      <a href="${item.url}" class="txt-primary">
        <span>${item.title}</span>
        <i class="i i-caret-right txt-secondary"></i>
      </a>
    </h5>
    ` : ''}
    ${!item.url ? `
    <h5 class="no-margin txt-primary">${item.title}</h5>
    ` : ''}
    <p>${stringFormatter(item.body, 30, null)}</p>
  </div>
</div>
  `
}, '')}`
